module.exports = __webpack_public_path__ + "img/qrcode.b71d27dc.jpg";